import { Button, createStyles, Grid, makeStyles, Typography } from "@material-ui/core";
import { theme } from "config/theme";
import useText from "constants/text";
import Dialog from "ui/Dialog";
import React from "react";

export const useValidationDialogStyle = makeStyles((Theme) =>
  createStyles({
    dialog: {
      overflowY: "unset",
      [theme.breakpoints.down("xs")]: {
        height: "80%",
      },
    },
    container: {
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      gap: 20,
    },

    yesButton: {
      height: 50,
      fontWeight: "bold",
      "&:hover": {
        background: "#1f9cc4",
      },
      background: "#399EBF",
    },
    cancelButton: {
      height: 50,
      background: "#CFECF9",
      border: "1px solid #399EBF",
      margin: "15px 0px 0px 0px",
      color: "#399EBF",
      fontWeight: "bold",
      "&:hover": {
        background: "#CFECF9",
      },
    },
    message: {
      fontSize: 23,
      color: "#757A93",
      margin: "95px 0px 65px 0px",
      [theme.breakpoints.down("xs")]: {
        paddingTop: 32,
        marginBottom: -6,
        marginTop: "18px",
        fontFamily: "Montserrat",
        fontSize: "16px",
        fontWeight: 500,
        fontStyle: "italic",
        lineHeight: 1.88,
        textAlign: "center",
        color: "#757a93",
      },
    },
    circle: {
      height: 140,
      width: 140,
      background: "#399EBF",
      borderRadius: "50%",
      position: "absolute",
      top: 5,
      left: "50%",
      transform: "translate(-50%, -50%)",
      border: "3px solid #fff",
      [theme.breakpoints.down("xs")]: {
        height: 84,
        width: 84,
        flexGrow: 0,
        margin: "0 0 2.6px",
        border: "solid 3px #e9e6e6",
        backgroundColor: "#399ebf",
        top: "27px",
        zIndex: 1,
        position: "absolute",
      },
    },
    helperIcon: {
      fontSize: 60,
      fontWeight: "bolder",
      fontStyle: "italic",
      color: "#fff",
      position: "relative",
      left: "40%",
      top: "15%",
      transform: "translateY(-50%, -50%)",
      [theme.breakpoints.down("xs")]: {
        width: 18.5,
        height: 72.6,
        flexGrow: 0,
        margin: "-7px 32.5px 0 0px",
        fontFamily: "Montserrat",
        fontSize: "48px",
        fontWeight: "bold",
        fontStyle: "italic",
        textAlign: "left",
        color: "#fff",
      },
    },
  })
);

interface ValidateDialogProps {
  open: boolean;
  onConfirm?: () => void;
  onClose?: () => void;
  handleCancel?: () => void;
  message?: string;
}

function ValidateDialog({ open, handleCancel, onConfirm, onClose }: ValidateDialogProps) {
  const { text } = useText();
  const classes = useValidationDialogStyle();

  return (
    <div>
      <div>
        <Dialog
          open={open}
          confirmButtonTitle={text.all.confirm}
          cancelButtonTitle={text.all.cancel}
          handleClose={onClose}
          handleConfirm={onConfirm}
          maxWidth="xs"
          hideDialogHeader
          dialogActionButtonCustomized
          classes={{ paper: classes.dialog }}
          className={classes.dialog}
        >
          <div className={classes.circle}>
            <Typography className={classes.helperIcon}>i</Typography>
          </div>
          <Grid container spacing={5}>
            <Grid item xs={12} className={classes.container}>
              <p className={classes.message}>{text.requestQuote.mad_request_message_creation}</p>
              <Button
                variant="contained"
                onClick={onConfirm}
                color="primary"
                className={classes.yesButton}
                size="large"
              >
                {text.requestQuote.mad_request_button_creation}
              </Button>
              <Button variant="contained" onClick={onClose} className={classes.cancelButton} size="large">
                {text.requestQuote.mad_request_message_update}
              </Button>
              <Button variant="contained" onClick={handleCancel} className={classes.cancelButton} size="large">
                {text.requestQuote.mad_request_message_delete}
              </Button>
            </Grid>
          </Grid>
        </Dialog>
      </div>
    </div>
  );
}

export default ValidateDialog;
